import clsx from "clsx";

import Skeleton from "~/components/Skeleton";
import type { JoiningPriceCopy } from "~/lib/membership-joining-price";

type Props = {
	copy: JoiningPriceCopy;
	isReady: boolean;
	isYearly: boolean;
	size?: "modal" | "page";
};

/** Plan-card headline and sublines from the joining-price copy. */
const BecomeAMemberJoiningPlanCopy = ({
	copy,
	isReady,
	isYearly,
	size = "modal",
}: Props) => {
	if (!isReady) {
		return (
			<div className="flex w-full flex-col gap-1.5" aria-busy="true">
				<Skeleton className={size === "page" ? "h-7 w-48" : "h-5 w-40"} />
				<Skeleton className="h-3.5 w-56" />
			</div>
		);
	}

	return (
		<div className="flex flex-col gap-0.5">
			<span
				className={clsx("font-semibold tabular-nums", {
					"text-xl sm:text-2xl": size === "page",
				})}
			>
				{copy.headline}
			</span>
			{copy.subline && (
				<span
					className={clsx("leading-snug", {
						"text-xs": size === "modal",
						"mt-0.5 text-sm": size === "page",
						"text-emerald-600 dark:text-emerald-300": isYearly,
						"text-slate-500 dark:text-slate-400": !isYearly,
					})}
				>
					{copy.subline}
				</span>
			)}
		</div>
	);
};

export default BecomeAMemberJoiningPlanCopy;
